var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "id": "ground",
            "title": "Solution",
            "src": "/images/sub/subvisual-solution.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first",
    scopedSlots: _vm._u([{
      key: "titleLine",
      fn: function fn() {
        return [_vm._v(" Smart Farm Solution ")];
      },
      proxy: true
    }])
  }, [_c('tit-wrap-large', {
    scopedSlots: _vm._u([{
      key: "text",
      fn: function fn() {
        return [_vm._v(" The system supplies the proper amount of water and nutrients required "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("for crops growing in outdoor soil, which is difficult for artificial environment management. "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("It enables efficient soil cultivation environment management and enhances the efficiency and productivity of crops. "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v(" It maintains the optimal crop growth environment by continuously monitoring the outdoor cultivation environment "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("and root zones of crops and controlling nutrients and irrigation. ")];
      },
      proxy: true
    }])
  }, [_vm._v(" A system that identifies crops’ necessary elements by acquiring data on the soil environment "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _c('b', [_vm._v("Outdoor Smart Farm")])])], 1), _c('v-container', [_c('v-divider', {
    staticClass: "grey lighten-3"
  })], 1), _c('page-section', [_c('page-section', {
    staticClass: "page-section--sm py-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-row', {
          staticClass: "mx-n20px my-n10px mx-md-n30px my-md-n20px"
        }, [_c('v-col', {
          staticClass: "px-20px py-10px px-md-30px py-md-20px",
          attrs: {
            "cols": "12",
            "md": "6",
            "data-aos": "fade-left",
            "data-aos-delay": "200"
          }
        }, [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": ""
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 570 / 456,
            "content-class": "d-flex"
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "570",
            "aspect-ratio": 570 / 456,
            "src": "/images/sub/solution/smartfarm/ground-img.jpg"
          }
        })], 1)], 1)], 1), _c('v-col', {
          staticClass: "px-20px py-10px px-md-30px py-md-20px",
          attrs: {
            "cols": "12",
            "md": "6",
            "data-aos": "fade-right",
            "data-aos-delay": "200"
          }
        }, [_c('div', [_c('tit-wrap-sprout', {
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" Crop cultivation soil data collector ")];
            },
            proxy: true
          }])
        }, [_vm._v(" Outdoor Smart Farm ")]), _c('txt-item', {
          attrs: {
            "titleClass": "w-md-140px"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("Measurement items")];
            },
            proxy: true
          }])
        }, [_vm._v(" External temperature, humidity, radiant/soil temperature, EC, and moisture ")]), _c('div', {
          staticClass: "mt-16px mt-md-24px"
        }, [_c('v-img', {
          attrs: {
            "max-width": "496",
            "aspect-ratio": 496 / 272,
            "src": "/images/sub/solution/smartfarm/ground-img2-en.png"
          }
        })], 1)], 1)])], 1)];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--sm pb-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-card', {
          attrs: {
            "rounded": "",
            "color": "grey lighten-5",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 1200 / 770,
            "content-class": "d-flex align-center justify-center"
          }
        }, [_c('div', {
          staticClass: "pa-30px pa-md-40px px-lg-80px"
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "max-width": "600",
            "width": _vm.$vuetify.breakpoint.lgAndUp ? '600' : '',
            "aspect-ratio": 600 / 376,
            "src": "/images/sub/solution/smartfarm/ground-img3.png"
          }
        }), _c('div', {
          staticClass: "pt-30px pt-md-40px pt-lg-60px"
        }, [_c('tit-wrap-small', {
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v("You can easily monitor data on the crop cultivation soil via the Internet and mobile device.")];
            },
            proxy: true
          }])
        }, [_vm._v(" Easy and simple real-time monitoring via the Internet and mobile device ")])], 1)], 1)])], 1)];
      },
      proxy: true
    }])
  })], 1), _c('v-container', [_c('v-divider', {
    staticClass: "grey lighten-3"
  })], 1), _c('page-section', {
    staticClass: "page-section--last",
    attrs: {
      "id": "ground-portfolio"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v(" Portfolio ")];
      },
      proxy: true
    }, {
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('div', {
          staticClass: "mx-auto px-12px",
          staticStyle: {
            "max-width": "1480px"
          }
        }, [_c('ground-slide')], 1)];
      },
      proxy: true
    }])
  }, [_c('div')])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }